import {NgModule} from '@angular/core';
import {SharedModule} from '@ispm/shared/shared.module';
import {CoreModule} from '@ispm/core/core.module';
import {DynamicFormModule} from '@ispm/dynamic-form/dynamic-form.module';
import {FloatingPanelComponent} from '@ispm-client/modules/selection-item/components/floating-panel/floating-panel.component';
import {GenericSelectionItemComponent} from '@ispm-client/modules/selection-item/components/generic-selection-item/generic-selection-item.component';
import {GenericSubSelectionComponent} from '@ispm-client/modules/selection-item/components/generic-sub-selection/generic-sub-selection.component';
import {ItemSelectionService} from '@ispm-client/modules/selection-item/services/item-selection.service';
import {CheckboxModule} from 'primeng/checkbox';
import {FormsModule} from '@angular/forms';
import {DataNotificationComponent} from '@ispm-client/modules/selection-item/components/data-notification/data-notification.component';
import {DataNotificationService} from '@ispm-client/modules/selection-item/services/data-notification.service';
import {GetItemsDataService} from '@ispm-client/modules/selection-item/services/get-items-data.service';
import {GetModelContextService} from '@ispm-client/modules/selection-item/services/get-model-context.service';
import {ArraySortPipe} from '@ispm-client/modules/selection-item/pipes/sortBy.pipe';
import {RecommendedListComponent} from "@ispm-client/modules/selection-item/components/recommended-list/recommended-list.component";
import {StoreModule} from "@ngrx/store";
import {itemReducer} from "@ispm-client/modules/selection-item/store/reducers/item.reducer";
import {EffectsModule} from "@ngrx/effects";
import {ItemEffects} from "@ispm-client/modules/selection-item/store/actions/item.effects";
import {FloatingPanelService} from '@ispm-client/modules/selection-item/services/floating-panel.service';
import {LayoutModule} from "@ispm/layout/layout.module";

@NgModule({
  imports: [
    CoreModule,
    SharedModule,
    CheckboxModule,
    LayoutModule,
    FormsModule,
    DynamicFormModule,
    StoreModule.forFeature('treeItems', itemReducer),
    EffectsModule.forFeature([ItemEffects])
  ],
  declarations: [
    FloatingPanelComponent,
    GenericSelectionItemComponent,
    GenericSubSelectionComponent,
    DataNotificationComponent,
    RecommendedListComponent,
    ArraySortPipe
  ],
  providers: [ItemSelectionService, DataNotificationService, GetItemsDataService, GetModelContextService, FloatingPanelService],
  exports: [FloatingPanelComponent, GenericSelectionItemComponent, GenericSubSelectionComponent, DataNotificationComponent, RecommendedListComponent]
})
export class SelectionItemModule { }
